// extracted by mini-css-extract-plugin
module.exports = {"outer":"AnimatedText_outer__LSiE4","inner":"AnimatedText_inner__PmJni","visible":"AnimatedText_visible__dvT-v","fw":"AnimatedText_fw__FR4bX"};